export const config = {
  default: {
    development: {
      common: "https://mr.xymind.net:9901",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://mr.xymind.net:9901/cent-data-core",
      workorder: "https://mr.xymind.net:9901/cent-order",
      school: "https://mr.xymind.net:9901/platform-campus",
      patrol: "https://mr.xymind.net:9901/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://mr.xymind.net:9901/cent-question",
      security: "https://mr.xymind.net:9901/cent-security",
      vehicle: "https://mr.xymind.net:9901/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://mr.xymind.net:9901/cent-talkback",
      device: "https://mr.xymind.net:9901/cent-device",
      socketLogin: "https://mr.xymind.net:9901/cent-message",
      business: "https://mr.xymind.net:9901/platform-business",
      park: "https://mr.xymind.net:9901/cent-zone-operation",
      eesd: "https://mr.xymind.net:9901/cent-eesd",
      auth: "https://mr.xymind.net:9901/cent-auth",
      ifmDynamicServeUrl: "https://mr.xymind.net:9901/cent-consumer",
      residence: "https://mr.xymind.net:9901/platform-residence",
      finance: "https://mr.xymind.net:9901/cent-biz-fin",
      face: "https://mr.xymind.net:9901/cent-face",
      iotDate: "https://mr.xymind.net:9901/cent-iot-data/",
      industrial: "https://mr.xymind.net:9901/platform-industrial",
      upgrade: "https://mr.xymind.net:9901/cent-upgrade",
      attendance: "https://mr.xymind.net:9901/cent-attendance",
      product: "https://mr.xymind.net:9901/cent-product",
      flow: "https://mr.xymind.net:9901/cent-workflow",
      sdkAppId: 1400528184,
      lanTalkWebSocket: "ws://10.10.101.102:9250",
      lanTalk: "http://10.10.101.102:9250",
      h5View: "/h5/view/",
      healthAged: "https://mr.xymind.net:9901/platform-health-aged",
      smarthome: "https://mr.xymind.net:9901/cent-smarthome",
      meeting: "https://mr.xymind.net:9901/cent-boardroom",
      baiduAk: "7cPwN5IjZTC5i2tUrcejkOZWrQKSua6s",
      oam: "https://mr.xymind.net:9901/cent-oam",
      iotProduct: "https://mr.xymind.net:9901/productcore-webapi",
      iotService: "https://mr.xymind.net:9901/devicecore-webapi",
      initConfig: "https://mr.xymind.net:9901/cent-init-config",
      service: "https://mr.xymind.net:9901/service-alliance",
    },
    dev: {
      common: "https://mr.xymind.net:9901",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://mr.xymind.net:9901/cent-data-core",
      workorder: "https://mr.xymind.net:9901/cent-order",
      school: "https://mr.xymind.net:9901/platform-campus",
      patrol: "https://mr.xymind.net:9901/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://mr.xymind.net:9901/cent-question",
      security: "https://mr.xymind.net:9901/cent-security",
      vehicle: "https://mr.xymind.net:9901/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://mr.xymind.net:9901/cent-talkback",
      device: "https://mr.xymind.net:9901/cent-device",
      socketLogin: "https://mr.xymind.net:9901/cent-message",
      business: "https://mr.xymind.net:9901/platform-business",
      park: "https://mr.xymind.net:9901/cent-zone-operation",
      eesd: "https://mr.xymind.net:9901/cent-eesd",
      auth: "https://mr.xymind.net:9901/cent-auth",
      ifmDynamicServeUrl: "https://mr.xymind.net:9901/cent-consumer",
      residence: "https://mr.xymind.net:9901/platform-residence",
      finance: "https://mr.xymind.net:9901/cent-biz-fin",
      face: "https://mr.xymind.net:9901/cent-face",
      iotDate: "https://mr.xymind.net:9901/cent-iot-data/",
      industrial: "https://mr.xymind.net:9901/platform-industrial",
      upgrade: "https://mr.xymind.net:9901/cent-upgrade",
      attendance: "https://mr.xymind.net:9901/cent-attendance",
      product: "https://mr.xymind.net:9901/cent-product",
      flow: "https://mr.xymind.net:9901/cent-workflow",
      sdkAppId: 1400528184,
      lanTalkWebSocket: "ws://10.10.101.102:9250",
      lanTalk: "http://10.10.101.102:9250",
      h5View: "/h5/view/",
      healthAged: "https://mr.xymind.net:9901/platform-health-aged",
      smarthome: "https://mr.xymind.net:9901/cent-smarthome",
      meeting: "https://mr.xymind.net:9901/cent-boardroom",
      baiduAk: "7cPwN5IjZTC5i2tUrcejkOZWrQKSua6s",
      oam: "https://mr.xymind.net:9901/cent-oam",
      iotProduct: "https://mr.xymind.net:9901/productcore-webapi",
      iotService: "https://mr.xymind.net:9901/devicecore-webapi",
      initConfig: "https://mr.xymind.net:9901/cent-init-config",
      service: "https://mr.xymind.net:9901/service-alliance",
    },
    test: {
      common: "https://cent.xymind.net:19900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://cent.xymind.net:19900/cent-data-core",
      workorder: "https://cent.xymind.net:19900/cent-order",
      school: "https://cent.xymind.net:19900/platform-campus",
      patrol: "https://cent.xymind.net:19900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://cent.xymind.net:19900/cent-question",
      security: "https://cent.xymind.net:19900/cent-security",
      vehicle: "https://cent.xymind.net:19900/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://cent.xymind.net:19900/cent-talkback",
      device: "https://cent.xymind.net:19900/cent-device",
      socketLogin: "https://cent.xymind.net:19900/cent-message",
      business: "https://cent.xymind.net:19900/platform-business",
      park: "https://cent.xymind.net:19900/cent-zone-operation",
      eesd: "https://cent.xymind.net:19900/cent-eesd",
      auth: "https://cent.xymind.net:19900/cent-auth",
      ifmDynamicServeUrl: "https://cent.xymind.net:19900/cent-consumer",
      residence: "https://cent.xymind.net:19900/platform-residence",
      finance: "https://cent.xymind.net:19900/cent-biz-fin",
      face: "https://cent.xymind.net:19900/cent-face",
      iotDate: "https://cent.xymind.net:19900/cent-iot-data/",
      industrial: "https://cent.xymind.net:19900/platform-industrial",
      upgrade: "https://cent.xymind.net:19900/cent-upgrade",
      attendance: "https://cent.xymind.net:19900/cent-attendance",
      product: "https://cent.xymind.net:19900/cent-product",
      smartHome: "https://cent.xymind.net:19040/uploadApi/",
      iot: "https://cent.xymind.net:19900/iot-webapi",
      workSummary: "https://cent.xymind.net:19900/cent-bi",
      sdkAppId: 1400694143,
      lanTalkWebSocket: "ws://10.10.101.102:9250",
      lanTalk: "http://10.10.101.102:9250",
      h5View: "/h5/view/",
      healthAged: "https://cent.xymind.net:19900/platform-health-aged",
      smarthome: "https://cent.xymind.net:19900/cent-smarthome",
      flow: "https://cent.xymind.net:19900/cent-workflow",
      meeting: "https://cent.xymind.net:19900/cent-boardroom",
      baiduAk: "7cPwN5IjZTC5i2tUrcejkOZWrQKSua6s",
      oam: "https://cent.xymind.net:19900/cent-oam",
      iotProduct: "https://cent.xymind.net:19900/productcore-webapi",
      iotService: "https://cent.xymind.net:19900/devicecore-webapi",
      initConfig: "https://cent.xymind.net:19900/cent-init-config",
      exam: "https://cent.xymind.net:19900/cent-exam",
      service: "https://cent.xymind.net:19900/service-alliance",
    },
    pre: {
      common: "https://cent-pre.xhmind.com:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://cent-pre.xhmind.com:9900/cent-data-core",
      workorder: "https://cent-pre.xhmind.com:9900/cent-order",
      school: "https://cent-pre.xhmind.com:9900/platform-campus",
      patrol: "https://cent-pre.xhmind.com:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://cent-pre.xhmind.com:9900/cent-question",
      security: "https://cent-pre.xhmind.com:9900/cent-security",
      vehicle: "https://cent-pre.xhmind.com:9900/cent-vehicle",
      mApi: "https://cent-pre.xhmind.com",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://cent-pre.xhmind.com:9900/cent-talkback",
      device: "https://cent-pre.xhmind.com:9900/cent-device",
      socketLogin: "https://cent-pre.xhmind.com:9900/cent-message",
      business: "https://cent-pre.xhmind.com:9900/platform-business",
      park: "https://cent-pre.xhmind.com:9900/cent-zone-operation",
      eesd: "https://cent-pre.xhmind.com:9900/cent-eesd",
      auth: "https://cent-pre.xhmind.com:9900/cent-auth",
      ifmDynamicServeUrl: "https://cent-pre.xhmind.com:9900/cent-consumer",
      residence: "https://cent-pre.xhmind.com:9900/platform-residence",
      finance: "https://cent-pre.xhmind.com:9900/cent-biz-fin",
      face: "https://cent-pre.xhmind.com:9900/cent-face",
      iotDate: "https://cent-pre.xhmind.com:9900/cent-iot-data/",
      industrial: "https://cent-pre.xhmind.com:9900/platform-industrial",
      upgrade: "https://cent-pre.xhmind.com:9900/cent-upgrade",
      product: "https://cent-pre.xhmind.com:9900/cent-product",
      attendance: "https://cent-pre.xhmind.com:9900/cent-attendance",
      iot: "https://cent-pre.xhmind.com:9900/iot-webapi",
      workSummary: "https://cent-pre.xhmind.com:9900/cent-bi",
      sdkAppId: 1400694207,
      h5View: "/h5/view/",
      healthAged: "https://cent-pre.xhmind.com:9900/platform-health-aged",
      smarthome: "https://cent-pre.xhmind.com:9900/cent-smarthome",
      flow: "https://cent-pre.xhmind.com:9900/cent-workflow",
      meeting: "https://cent-pre.xhmind.com:9900/cent-boardroom",
      baiduAk: "7cPwN5IjZTC5i2tUrcejkOZWrQKSua6s",
      oam: "https://cent-pre.xhmind.com:9900/cent-oam",
      iotProduct: "https://cent-pre.xhmind.com:9900/productcore-webapi",
      iotService: "https://cent-pre.xhmind.com:9900/devicecore-webapi",
      initConfig: "https://cent-pre.xhmind.com:9900/cent-init-config",
      service: "https://cent-pre.xhmind.com:9900/service-alliance",
    },
    production: {
      common: "https://cent.xhmind.com:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://cent.xhmind.com:9900/cent-data-core",
      workorder: "https://cent.xhmind.com:9900/cent-order",
      school: "https://cent.xhmind.com:9900/platform-campus",
      patrol: "https://cent.xhmind.com:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://cent.xhmind.com:9900/cent-question",
      security: "https://cent.xhmind.com:9900/cent-security",
      vehicle: "https://cent.xhmind.com:9900/cent-vehicle",
      mApi: "https://cent.xhmind.com",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://cent.xhmind.com:9900/cent-talkback",
      device: "https://cent.xhmind.com:9900/cent-device",
      socketLogin: "https://cent.xhmind.com:9900/cent-message",
      business: "https://cent.xhmind.com:9900/platform-business",
      park: "https://cent.xhmind.com:9900/cent-zone-operation",
      eesd: "https://cent.xhmind.com:9900/cent-eesd",
      auth: "https://cent.xhmind.com:9900/cent-auth",
      ifmDynamicServeUrl: "https://cent.xhmind.com:9900/cent-consumer",
      residence: "https://cent.xhmind.com:9900/platform-residence",
      finance: "https://cent.xhmind.com:9900/cent-biz-fin",
      face: "https://cent.xhmind.com:9900/cent-face",
      industrial: "https://cent.xhmind.com:9900/platform-industrial",
      upgrade: "https://cent.xhmind.com:9900/cent-upgrade",
      product: "https://cent.xhmind.com:9900/cent-product",
      attendance: "https://cent.xhmind.com:9900/cent-attendance",
      iot: "https://cent.xhmind.com:9900/iot-webapi",
      workSummary: "https://cent.xhmind.com:9900/cent-bi",
      sdkAppId: 1400677520,
      h5View: "/h5/view/",
      healthAged: "https://cent.xhmind.com:9900/platform-health-aged",
      smarthome: "https://cent.xhmind.com:9900/cent-smarthome",
      flow: "https://cent.xhmind.com:9900/cent-workflow",
      meeting: "https://cent.xhmind.com:9900/cent-boardroom",
      baiduAk: "EL929iES4ftStTn1vDkt7FUh98Rzup1N",
      oam: "https://cent.xhmind.com:9900/cent-oam",
      iotProduct: "https://cent.xhmind.com:9900/productcore-webapi",
      iotService: "https://cent.xhmind.com:9900/devicecore-webapi",
      initConfig: "https://cent.xhmind.com:9900/cent-init-config",
      service: "https://cent.xhmind.com:9900/service-alliance",
    },
  },
  atls: {
    development: {
      common: "https://mr.xymind.net:9901",
      ifm: "http://172.50.57.23",
      main: "https://mr.xymind.net:9901/cent-data-core",
      workorder: "https://mr.xymind.net:9901/cent-order",
      school: "https://mr.xymind.net:9901/platform-campus",
      patrol: "https://mr.xymind.net:9901/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://mr.xymind.net:9901/cent-question",
      security: "https://mr.xymind.net:9901/cent-security",
      vehicle: "https://mr.xymind.net:9901/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "https://mr.xymind.net:9901/cent-device",
      initConfig: "https://mr.xymind.net:9901/cent-init-config",
    },
    test: {
      common: "http://172.50.57.37:9900",
      ifm: "http://172.50.57.23",
      main: "http://172.50.57.37:9900/cent-data-core",
      workorder: "http://172.50.57.37:9900/cent-order",
      school: "http://172.50.57.37:9900/platform-campus",
      patrol: "http://172.50.57.37:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://172.50.57.37:9900/cent-question",
      security: "http://172.50.57.37:9900/cent-security",
      vehicle: "http://172.50.57.37:9900/cent-vehicle",
      mApi: "http://172.50.57.37",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://172.50.57.37:9900/cent-device",
      eesd: "http://172.50.57.37:9900/cent-eesd",
      auth: "http://172.50.57.37:9900/cent-auth",
      cloudTalk: "http://172.50.57.37:9900/cent-talkback",
      socketLogin: "http://172.50.57.37:9900/cent-message",
      business: "http://172.50.57.37:9900/platform-business",
      park: "http://172.50.57.37:9900/cent-zone-operation",
      attendance: "http://172.50.57.37:9900/cent-attendance",
      ifmDynamicServeUrl: "http://172.50.57.37:9900/cent-consumer",
      face: "http://172.50.57.37:9900/cent-face",
      residence: "http://172.50.57.37:9900/platform-residence",
      finance: "http://172.50.57.37:9900/cent-biz-fin",
      industrial: "http://172.50.57.37:9900/platform-industrial",
      upgrade: "http://172.50.57.37:9900/cent-upgrade",
      product: "http://172.50.57.37:9900/cent-product",
      workSummary: "http://172.50.57.37:9900/cent-bi",
      h5View: "/h5/view/",
      flow: "http://172.50.57.37:9900/cent-workflow",
      initConfig: "http://172.50.57.37:9900/cent-init-config",
    },
    production: {
      common: "http://172.50.57.12:9900",
      ifm: "http://172.50.57.23",
      main: "http://172.50.57.12:9900/cent-data-core",
      workorder: "http://172.50.57.12:9900/cent-order",
      school: "http://172.50.57.12:9900/platform-campus",
      patrol: "http://172.50.57.12:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://172.50.57.12:9900/cent-question",
      security: "http://172.50.57.12:9900/cent-security",
      vehicle: "http://172.50.57.12:9900/cent-vehicle",
      mApi: "http://172.50.57.12",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://172.50.57.12:9900/cent-device",
      eesd: "http://172.50.57.12:9900/cent-eesd",
      auth: "http://172.50.57.12:9900/cent-auth",
      cloudTalk: "http://172.50.57.12:9900/cent-talkback",
      socketLogin: "http://172.50.57.12:9900/cent-message",
      business: "http://172.50.57.12:9900/platform-business",
      park: "http://172.50.57.12:9900/cent-zone-operation",
      attendance: "http://172.50.57.12:9900/cent-attendance",
      ifmDynamicServeUrl: "http://172.50.57.12:9900/cent-consumer",
      face: "http://172.50.57.12:9900/cent-face",
      residence: "http://172.50.57.12:9900/platform-residence",
      finance: "http://172.50.57.12:9900/cent-biz-fin",
      industrial: "http://172.50.57.12:9900/platform-industrial",
      upgrade: "http://172.50.57.12:9900/cent-upgrade",
      product: "http://172.50.57.12:9900/cent-product",
      workSummary: "http://172.50.57.12:9900/cent-bi",
      h5View: "/h5/view/",
      flow: "http://172.50.57.12:9900/cent-workflow",
      initConfig: "http://172.50.57.12:9900/cent-init-config",
    },
  },
  jm: {
    development: {
      common: "https://mr.xymind.net:9901",
      ifm: "http://172.50.57.23",
      main: "https://mr.xymind.net:9901/cent-data-core",
      workorder: "https://mr.xymind.net:9901/cent-order",
      school: "https://mr.xymind.net:9901/platform-campus",
      patrol: "https://mr.xymind.net:9901/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://mr.xymind.net:9901/cent-question",
      security: "https://mr.xymind.net:9901/cent-security",
      vehicle: "https://mr.xymind.net:9901/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "https://mr.xymind.net:9901/cent-device",
      initConfig: "https://mr.xymind.net:9901/cent-init-config",
    },
    test: {
      common: "http://172.50.57.37:9900",
      auth: "http://172.50.57.37:9900/cent-auth",
      main: "http://172.50.57.37:9900/cent-data-core",
      workorder: "http://172.50.57.37:9900/cent-order",
      school: "http://172.50.57.37:9900/platform-campus",
      patrol: "http://172.50.57.37:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://172.50.57.37:9900/cent-question",
      security: "http://172.50.57.37:9900/cent-security",
      vehicle: "http://172.50.57.37:9900/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://172.50.57.37:9900/cent-device",
      ifm: "http://172.50.57.37",
      eesd: "http://172.50.57.37:9900/cent-eesd",
      cloudTalk: "http://172.50.57.37:9900/cent-talkback",
      socketLogin: "http://172.50.57.37:9900/cent-message",
      business: "http://172.50.57.37:9900/platform-business",
      park: "http://172.50.57.37:9900/cent-zone-operation",
      ifmDynamicServeUrl: "http://172.50.57.37:9900/cent-consumer",
      initConfig: "http://172.50.57.37:9900/cent-init-config",
    },
    pre: {
      common: "http://172.50.57.12:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://172.50.57.12:9900/cent-data-core",
      workorder: "http://172.50.57.12:9900/cent-order",
      school: "http://172.50.57.12:9900/platform-campus",
      patrol: "http://172.50.57.12:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://172.50.57.12:9900/cent-question",
      security: "http://172.50.57.12:9900/cent-security",
      vehicle: "http://172.50.57.12:9900/cent-vehicle",
      mApi: "http://172.50.57.12",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://172.50.57.12:9900/cent-device",
      ifmDynamicServeUrl: "http://172.50.57.12:9900/cent-consumer",
      initConfig: "http://172.50.57.12:9900/cent-init-config",
    },
    production: {
      common: "http://10.21.100.58:9900",
      ifm: "http://172.50.57.23",
      main: "http://10.21.100.58:9900/cent-data-core",
      workorder: "http://10.21.100.58:9900/cent-order",
      school: "http://10.21.100.58:9900/platform-campus",
      patrol: "http://10.21.100.58:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://10.21.100.58:9900/cent-question",
      security: "http://10.21.100.58:9900/cent-security",
      vehicle: "http://10.21.100.58:9900/cent-vehicle",
      mApi: "http://172.50.57.12",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://10.21.100.58:9900/cent-device",
      eesd: "http://10.21.100.58:9900/cent-eesd",
      auth: "http://10.21.100.58:9900/cent-auth",
      cloudTalk: "http://10.21.100.58:9900/cent-talkback",
      socketLogin: "http://10.21.100.58:9900/cent-message",
      business: "http://10.21.100.58:9900/platform-business",
      park: "http://10.21.100.58:9900/cent-zone-operation",
      ifmDynamicServeUrl: "http://10.21.100.58:9900/cent-consumer",
      workSummary: "http://10.21.100.58:9900/cent-bi",
      initConfig: "http://10.21.100.58:9900/cent-init-config",
    },
  },
  lsw: {
    development: {
      common: "https://mr.xymind.net:9901",
      ifm: "http://172.50.57.23",
      main: "https://mr.xymind.net:9901/cent-data-core",
      workorder: "https://mr.xymind.net:9901/cent-order",
      school: "https://mr.xymind.net:9901/platform-campus",
      patrol: "https://mr.xymind.net:9901/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://mr.xymind.net:9901/cent-question",
      security: "https://mr.xymind.net:9901/cent-security",
      vehicle: "https://mr.xymind.net:9901/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "https://mr.xymind.net:9901/cent-device",
      initConfig: "https://mr.xymind.net:9901/cent-init-config",
    },
    test: {
      common: "http://172.50.57.37:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://172.50.57.37:9900/cent-data-core",
      workorder: "http://172.50.57.37:9900/cent-order",
      school: "http://172.50.57.37:9900/platform-campus",
      patrol: "http://172.50.57.37:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://cent.xymind.net:19900/cent-question",
      security: "https://cent.xymind.net:19900/cent-security",
      vehicle: "https://cent.xymind.net:19900/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "https://cent.xymind.net:19900/cent-device",
      initConfig: "http://172.50.57.37:9900/cent-init-config",
    },
    pre: {
      common: "http://139.159.141.233:9900",
      main: "http://139.159.141.233:9900/cent-data-core",
      workorder: "http://139.159.141.233:9900/cent-order",
      school: "http://139.159.141.233:9900/platform-campus",
      patrol: "http://139.159.141.233:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://139.159.141.233:9900/cent-question",
      security: "http://139.159.141.233:9900/cent-security",
      vehicle: "http://139.159.141.233:9900/cent-vehicle",
      mApi: "http://172.50.57.12",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://139.159.141.233:9900/cent-device",
      eesd: "http://139.159.141.233:9900/cent-eesd",
      auth: "http://139.159.141.233:9900/cent-auth",
      cloudTalk: "http://139.159.141.233:9900/cent-talkback",
      socketLogin: "http://139.159.141.233:9900/cent-message",
      business: "http://139.159.141.233:9900/platform-business",
      park: "http://139.159.141.233:9900/cent-zone-operation",
      initConfig: "http://139.159.141.233:9900/cent-init-config",
    },
    production: {
      common: "http://139.159.141.233:9900",
      main: "http://139.159.141.233:9900/cent-data-core",
      workorder: "http://139.159.141.233:9900/cent-order",
      school: "http://139.159.141.233:9900/platform-campus",
      patrol: "http://139.159.141.233:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://139.159.141.233:9900/cent-question",
      security: "http://139.159.141.233:9900/cent-security",
      vehicle: "http://139.159.141.233:9900/cent-vehicle",
      mApi: "http://172.50.57.12",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://139.159.141.233:9900/cent-device",
      eesd: "http://139.159.141.233:9900/cent-eesd",
      auth: "http://139.159.141.233:9900/cent-auth",
      cloudTalk: "http://139.159.141.233:9900/cent-talkback",
      socketLogin: "http://139.159.141.233:9900/cent-message",
      business: "http://139.159.141.233:9900/platform-business",
      park: "http://139.159.141.233:9900/cent-zone-operation",
      workSummary: "http://139.159.141.233:9900/cent-bi",
      initConfig: "http://139.159.141.233:9900/cent-init-config",
    },
  },
  xyh: {
    development: {
      common: "https://mr.xymind.net:9901",
      ifm: "http://172.50.57.23",
      main: "https://mr.xymind.net:9901/cent-data-core",
      workorder: "https://mr.xymind.net:9901/cent-order",
      school: "https://mr.xymind.net:9901/platform-campus",
      patrol: "https://mr.xymind.net:9901/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://mr.xymind.net:9901/cent-question",
      security: "https://mr.xymind.net:9901/cent-security",
      vehicle: "https://mr.xymind.net:9901/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "https://mr.xymind.net:9901/cent-device",
      initConfig: "https://mr.xymind.net:9901/cent-init-config",
    },
    test: {
      common: "http://172.50.57.37:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://172.50.57.37:9900/cent-data-core",
      workorder: "http://172.50.57.37:9900/cent-order",
      school: "http://172.50.57.37:9900/platform-campus",
      patrol: "http://172.50.57.37:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://cent.xymind.net:19900/cent-question",
      security: "https://cent.xymind.net:19900/cent-security",
      vehicle: "https://cent.xymind.net:19900/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "https://cent.xymind.net:19900/cent-device",
      initConfig: "http://172.50.57.37:9900/cent-init-config",
    },
    pre: {
      common: "http://58.20.99.227:19900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://172.50.57.12:9900/cent-data-core",
      workorder: "http://58.20.99.227:19900/cent-order",
      school: "http://58.20.99.227:19900/platform-campus",
      patrol: "http://58.20.99.227:19900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://58.20.99.227:19900/cent-question",
      security: "http://58.20.99.227:19900/cent-security",
      vehicle: "http://58.20.99.227:19900/cent-vehicle",
      mApi: "http://172.50.57.12",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://58.20.99.227:19900/cent-device",
      initConfig: "http://172.50.57.12:9900/cent-init-config",
    },
    production: {
      common: "http://58.20.99.227:19900",
      ifm: "http://172.50.57.23",
      main: "http://58.20.99.227:19900/cent-data-core",
      workorder: "http://58.20.99.227:19900/cent-order",
      school: "http://58.20.99.227:19900/platform-campus",
      patrol: "http://58.20.99.227:19900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://58.20.99.227:19900/cent-question",
      security: "http://58.20.99.227:19900/cent-security",
      vehicle: "http://58.20.99.227:19900/cent-vehicle",
      mApi: "http://172.50.57.12",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://58.20.99.227:19900/cent-device",
      eesd: "http://58.20.99.227:19900/cent-eesd",
      auth: "http://58.20.99.227:19900/cent-auth",
      cloudTalk: "http://58.20.99.227:19900/cent-talkback",
      socketLogin: "http://58.20.99.227:19900/cent-message",
      business: "http://58.20.99.227:19900/platform-business",
      park: "http://58.20.99.227:19900/cent-zone-operation",
      ifmDynamicServeUrl: "http://58.20.99.227:19900/cent-consumer",
      residence: "http://58.20.99.227:19900/platform-residence",
      finance: "http://58.20.99.227:19900/cent-biz-fin",
      face: "http://58.20.99.227:19900/cent-face",
      iotDate: "http://58.20.99.227:19900/cent-iot-data/",
      industrial: "http://58.20.99.227:19900/platform-industrial",
      upgrade: "http://58.20.99.227:19900/cent-upgrade",
      attendance: "http://58.20.99.227:19900/cent-attendance",
      product: "http://58.20.99.227:19900/cent-product",
      workSummary: "http://58.20.99.227:19900/cent-bi",
      sdkAppId: 1400611171,
      initConfig: "http://58.20.99.227:19900/cent-init-config",
    },
  },
  wm: {
    development: {
      common: "http://10.4.15.129:9900",
      ifm: "http://172.50.57.23",
      main: "http://10.4.15.129:9900/cent-data-core",
      workorder: "http://10.4.15.129:9900/cent-order",
      school: "http://10.4.15.129:9900/platform-campus",
      patrol: "http://10.4.15.129:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://10.4.15.129:9900/cent-question",
      security: "http://10.4.15.129:9900/cent-security",
      vehicle: "http://10.4.15.129:9900/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://10.4.15.129:9900/cent-device",
      cloudTalk: "http://10.4.15.129:9900/cent-talkback",
      socketLogin: "http://10.4.15.129:9900/cent-message",
      guard: "http://10.4.15.129:9900/platform-guard",
      park: "http://10.4.15.129:9900/cent-zone-operation",
      eesd: "http://10.4.15.129:9900/cent-eesd",
      auth: "http://10.4.15.129:9900/cent-auth",
      industrial: "http://10.4.15.129:9900/platform-industrial",
      initConfig: "http://10.4.15.129:9900/cent-init-config",
    },
    test: {
      common: "http://10.4.15.129:9900",
      ifm: "http://172.50.57.23",
      main: "http://10.4.15.129:9900/cent-data-core",
      workorder: "http://10.4.15.129:9900/cent-order",
      school: "http://10.4.15.129:9900/platform-campus",
      patrol: "http://10.4.15.129:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://10.4.15.129:9900/cent-question",
      security: "http://10.4.15.129:9900/cent-security",
      vehicle: "http://10.4.15.129:9900/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://10.4.15.129:9900/cent-device",
      cloudTalk: "http://10.4.15.129:9900/cent-talkback",
      socketLogin: "http://10.4.15.129:9900/cent-message",
      guard: "http://10.4.15.129:9900/platform-guard",
      park: "http://10.4.15.129:9900/cent-zone-operation",
      eesd: "http://10.4.15.129:9900/cent-eesd",
      auth: "http://10.4.15.129:9900/cent-auth",
      industrial: "http://10.4.15.129:9900/platform-industrial",
      initConfig: "http://10.4.15.129:9900/cent-init-config",
    },
    pre: {
      common: "http://10.4.15.129:9900",
      ifm: "http://172.50.57.23",
      main: "http://10.4.15.129:9900/cent-data-core",
      workorder: "http://10.4.15.129:9900/cent-order",
      school: "http://10.4.15.129:9900/platform-campus",
      patrol: "http://10.4.15.129:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://10.4.15.129:9900/cent-question",
      security: "http://10.4.15.129:9900/cent-security",
      vehicle: "http://10.4.15.129:9900/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://10.4.15.129:9900/cent-device",
      cloudTalk: "http://10.4.15.129:9900/cent-talkback",
      socketLogin: "http://10.4.15.129:9900/cent-message",
      guard: "http://10.4.15.129:9900/platform-guard",
      park: "http://10.4.15.129:9900/cent-zone-operation",
      eesd: "http://10.4.15.129:9900/cent-eesd",
      auth: "http://10.4.15.129:9900/cent-auth",
      industrial: "http://10.4.15.129:9900/platform-industrial",
      initConfig: "http://10.4.15.129:9900/cent-init-config",
    },
    production: {
      common: "http://10.4.15.129:9900",
      ifm: "http://172.50.57.23",
      main: "http://10.4.15.129:9900/cent-data-core",
      workorder: "http://10.4.15.129:9900/cent-order",
      school: "http://10.4.15.129:9900/platform-campus",
      patrol: "http://10.4.15.129:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://10.4.15.129:9900/cent-question",
      security: "http://10.4.15.129:9900/cent-security",
      vehicle: "http://10.4.15.129:9900/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://10.4.15.129:9900/cent-device",
      cloudTalk: "http://10.4.15.129:9900/cent-talkback",
      socketLogin: "http://10.4.15.129:9900/cent-message",
      guard: "http://10.4.15.129:9900/platform-guard",
      park: "http://10.4.15.129:9900/cent-zone-operation",
      eesd: "http://10.4.15.129:9900/cent-eesd",
      auth: "http://10.4.15.129:9900/cent-auth",
      industrial: "http://10.4.15.129:9900/platform-industrial",
      workSummary: "http://10.4.15.129:9900/cent-bi",
      initConfig: "http://10.4.15.129:9900/cent-init-config",
    },
  },
  gznt: {
    development: {
      common: "https://mr.xymind.net:9901",
      ifm: "http://10.51.36.247",
      main: "https://mr.xymind.net:9901/cent-data-core",
      workorder: "https://mr.xymind.net:9901/cent-order",
      school: "https://mr.xymind.net:9901/platform-campus",
      patrol: "https://mr.xymind.net:9901/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://mr.xymind.net:9901/cent-question",
      security: "https://mr.xymind.net:9901/cent-security",
      vehicle: "https://mr.xymind.net:9901/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "https://mr.xymind.net:9901/cent-device",
      initConfig: "https://mr.xymind.net:9901/cent-init-config",
    },
    test: {
      common: "http://192.168.22.232:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://192.168.22.232:9900/cent-data-core",
      workorder: "http://192.168.22.232:9900/cent-order",
      school: "http://192.168.22.232:9900/platform-campus",
      patrol: "http://192.168.22.232:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://192.168.22.222:9900/cent-question",
      security: "http://192.168.22.222:9900/cent-security",
      vehicle: "http://192.168.22.222:9900/cent-vehicle",
      mApi: "http://192.168.22.222",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://192.168.22.222:9900/cent-device",
      initConfig: "http://192.168.22.232:9900/cent-init-config",
    },
    pre: {
      common: "http://192.168.22.222:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://192.168.22.222:9900/cent-data-core",
      workorder: "http://192.168.22.222:9900/cent-order",
      school: "http://192.168.22.222:9900/platform-campus",
      patrol: "http://192.168.22.222:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://192.168.22.222:9900/cent-question",
      security: "http://192.168.22.222:9900/cent-security",
      vehicle: "http://192.168.22.222:9900/cent-vehicle",
      mApi: "http://192.168.22.222",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://192.168.22.222:9900/cent-device",
      initConfig: "http://192.168.22.222:9900/cent-init-config",
    },
    production: {
      common: "http://192.168.22.222:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://192.168.22.222:9900/cent-data-core",
      workorder: "http://192.168.22.222:9900/cent-order",
      school: "http://192.168.22.222:9900/platform-campus",
      patrol: "http://192.168.22.222:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://192.168.22.222:9900/cent-question",
      security: "http://192.168.22.222:9900/cent-security",
      vehicle: "http://192.168.22.222:9900/cent-vehicle",
      mApi: "http://192.168.22.222",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://192.168.22.222:9900/cent-device",
      business: "http://192.168.22.222:9900/platform-business",
      cloudTalk: "http://192.168.22.222:9900/cent-talkback",
      socketLogin: "http://192.168.22.222:9900/cent-message",
      park: "http://192.168.22.222:9900/cent-zone-operation",
      eesd: "http://192.168.22.222:9900/cent-eesd",
      auth: "http://192.168.22.222:9900/cent-auth",
      ifmDynamicServeUrl: "http://192.168.22.222:9900/cent-consumer",
      residence: "http://192.168.22.222:9900/platform-residence",
      finance: "http://192.168.22.222:9900/cent-biz-fin",
      face: "http://192.168.22.222:9900/cent-face",
      iotDate: "http://192.168.22.222:9900/cent-iot-data/",
      industrial: "http://192.168.22.222:9900/platform-industrial",
      workSummary: "http://192.168.22.222:9900/cent-bi",
      initConfig: "http://192.168.22.222:9900/cent-init-config",
    },
  },
  hwkz: {
    development: {
      common: "https://mr.xymind.net:9901",
      ifm: "http://10.51.36.247",
      main: "https://mr.xymind.net:9901/cent-data-core",
      workorder: "https://mr.xymind.net:9901/cent-order",
      school: "https://mr.xymind.net:9901/platform-campus",
      patrol: "https://mr.xymind.net:9901/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://mr.xymind.net:9901/cent-question",
      security: "https://mr.xymind.net:9901/cent-security",
      vehicle: "https://mr.xymind.net:9901/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "https://mr.xymind.net:9901/cent-device",
      initConfig: "https://mr.xymind.net:9901/cent-init-config",
    },
    test: {
      common: "http://192.168.22.222:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://192.168.22.222:9900/cent-data-core",
      workorder: "http://192.168.22.222:9900/cent-order",
      school: "http://192.168.22.222:9900/platform-campus",
      patrol: "http://192.168.22.222:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://192.168.22.222:9900/cent-question",
      security: "http://192.168.22.222:9900/cent-security",
      vehicle: "http://192.168.22.222:9900/cent-vehicle",
      mApi: "http://192.168.22.222",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://192.168.22.222:9900/cent-device",
      initConfig: "http://192.168.22.222:9900/cent-init-config",
    },
    pre: {
      common: "http://192.168.22.222:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://192.168.22.222:9900/cent-data-core",
      workorder: "http://192.168.22.222:9900/cent-order",
      school: "http://192.168.22.222:9900/platform-campus",
      patrol: "http://192.168.22.222:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://192.168.22.222:9900/cent-question",
      security: "http://192.168.22.222:9900/cent-security",
      vehicle: "http://192.168.22.222:9900/cent-vehicle",
      mApi: "http://192.168.22.222",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "http://192.168.22.222:9900/cent-device",
      initConfig: "http://192.168.22.222:9900/cent-init-config",
    },
    production: {
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://cent.xymind.net:39000/cent-data-core",
      workorder: "https://cent.xymind.net:39000/cent-order",
      school: "https://cent.xymind.net:39000/platform-campus",
      patrol: "https://cent.xymind.net:39000/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://cent.xymind.net:39000/cent-question",
      security: "https://cent.xymind.net:39000/cent-security",
      vehicle: "https://cent.xymind.net:39000/cent-vehicle",
      mApi: "https://cent.xymind.net",
      filesUpload: "https://seven.xy-mind.com:18443",
      device: "https://cent.xymind.net:39000/cent-device",
      workSummary: "https://cent.xymind.net:39000/cent-bi",
      initConfig: "https://cent.xymind.net:39000/cent-init-config",
    },
  },
  nsh: {
    test: {
      common: "http://192.168.130.210:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://192.168.130.210:9900/cent-data-core",
      workorder: "http://192.168.130.210:9900/cent-order",
      school: "http://192.168.130.210:9900/platform-campus",
      patrol: "http://192.168.130.210:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://192.168.130.210:9900/cent-question",
      security: "http://192.168.130.210:9900/cent-security",
      vehicle: "http://192.168.130.210:9900/cent-vehicle",
      mApi: "https://cent.xhmind.com",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "http://192.168.130.210:9900/cent-talkback",
      device: "http://192.168.130.210:9900/cent-device",
      socketLogin: "http://192.168.130.210:9900/cent-message",
      business: "http://192.168.130.210:9900/platform-business",
      park: "http://192.168.130.210:9900/cent-zone-operation",
      eesd: "http://192.168.130.210:9900/cent-eesd",
      auth: "http://192.168.130.210:9900/cent-auth",
      ifmDynamicServeUrl: "http://192.168.130.210:9900/cent-consumer",
      residence: "http://192.168.130.210:9900/platform-residence",
      finance: "http://192.168.130.210:9900/cent-biz-fin",
      face: "http://192.168.130.210:9900/cent-face",
      industrial: "http://192.168.130.210:9900/platform-industrial",
      upgrade: "http://192.168.130.210:9900/cent-upgrade",
      product: "http://192.168.130.210:9900/cent-product",
      attendance: "http://192.168.130.210:9900/cent-attendance",
      iot: "http://192.168.130.210:9900/iot-webapi",
      workSummary: "http://192.168.130.210:9900/cent-bi",
      sdkAppId: 1400596395,
      h5View: "/h5/view/",
      smarthome: "http://192.168.130.210:9900/cent-smarthome",
      initConfig: "http://192.168.130.210:9900/cent-init-config",
    },
    production: {
      common: "http://192.168.130.207:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://192.168.130.207:9900/cent-data-core",
      workorder: "http://192.168.130.207:9900/cent-order",
      school: "http://192.168.130.207:9900/platform-campus",
      patrol: "http://192.168.130.207:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://192.168.130.207:9900/cent-question",
      security: "http://192.168.130.207:9900/cent-security",
      vehicle: "http://192.168.130.207:9900/cent-vehicle",
      mApi: "https://cent.xhmind.com",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "http://192.168.130.207:9900/cent-talkback",
      device: "http://192.168.130.207:9900/cent-device",
      socketLogin: "http://192.168.130.207:9900/cent-message",
      business: "http://192.168.130.207:9900/platform-business",
      park: "http://192.168.130.207:9900/cent-zone-operation",
      eesd: "http://192.168.130.207:9900/cent-eesd",
      auth: "http://192.168.130.207:9900/cent-auth",
      ifmDynamicServeUrl: "http://192.168.130.207:9900/cent-consumer",
      residence: "http://192.168.130.207:9900/platform-residence",
      finance: "http://192.168.130.207:9900/cent-biz-fin",
      face: "http://192.168.130.207:9900/cent-face",
      industrial: "http://192.168.130.207:9900/platform-industrial",
      upgrade: "http://192.168.130.207:9900/cent-upgrade",
      product: "http://192.168.130.207:9900/cent-product",
      attendance: "http://192.168.130.207:9900/cent-attendance",
      iot: "http://192.168.130.207:9900/iot-webapi",
      workSummary: "http://192.168.130.207:9900/cent-bi",
      sdkAppId: 1400596395,
      h5View: "/h5/view/",
      smarthome: "http://192.168.130.207:9900/cent-smarthome",
      initConfig: "http://192.168.130.207:9900/cent-init-config",
    },
  },
  fgy: {
    development: {
      common: "https://cent.xymind.net:19900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://cent.xymind.net:19900/cent-data-core",
      workorder: "https://cent.xymind.net:19900/cent-order",
      school: "https://cent.xymind.net:19900/platform-campus",
      patrol: "https://cent.xymind.net:19900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://cent.xymind.net:19900/cent-question",
      security: "https://cent.xymind.net:19900/cent-security",
      vehicle: "https://cent.xymind.net:19900/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://cent.xymind.net:19900/cent-talkback",
      device: "https://cent.xymind.net:19900/cent-device",
      socketLogin: "https://cent.xymind.net:19900/cent-message",
      business: "https://cent.xymind.net:19900/platform-business",
      park: "https://cent.xymind.net:19900/cent-zone-operation",
      eesd: "https://cent.xymind.net:19900/cent-eesd",
      auth: "https://cent.xymind.net:19900/cent-auth",
      ifmDynamicServeUrl: "https://cent.xymind.net:19900/cent-consumer",
      residence: "https://cent.xymind.net:19900/platform-residence",
      finance: "https://cent.xymind.net:19900/cent-biz-fin",
      face: "https://cent.xymind.net:19900/cent-face",
      iotDate: "https://cent.xymind.net:19900/cent-iot-data/",
      industrial: "https://cent.xymind.net:19900/platform-industrial",
      upgrade: "https://cent.xymind.net:19900/cent-upgrade",
      attendance: "https://cent.xymind.net:19900/cent-attendance",
      product: "https://cent.xymind.net:19900/cent-product",
      flow: "https://cent.xymind.net:19900/cent-workflow",
      sdkAppId: 1400528184,
      lanTalkWebSocket: "ws://10.10.101.102:9250",
      lanTalk: "http://10.10.101.102:9250",
      h5View: "/h5/view/",
      healthAged: "https://cent.xymind.net:19900/platform-health-aged",
      smarthome: "https://cent.xymind.net:19900/cent-smarthome",
      meeting: "https://cent.xymind.net:19900/cent-boardroom",
      baiduAk: "7cPwN5IjZTC5i2tUrcejkOZWrQKSua6s",
      oam: "https://cent.xymind.net:19900/cent-oam",
      iotProduct: "https://cent.xymind.net:19900/productcore-webapi",
      iotService: "https://cent.xymind.net:19900/devicecore-webapi",
      initConfig: "https://cent.xymind.net:19900/cent-init-config",
      iot: "https://cent.xymind.net:19900/iot-webapi",
    },
    test: {
      common: "http://192.168.234.208",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://192.168.234.208/cent-data-core",
      workorder: "http://192.168.234.208/cent-order",
      school: "http://192.168.234.208/platform-campus",
      patrol: "http://192.168.234.208/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://192.168.234.208/cent-question",
      security: "http://192.168.234.208/cent-security",
      vehicle: "http://192.168.234.208/cent-vehicle",
      mApi: "https://cent.xhmind.com",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "http://192.168.234.208/cent-talkback",
      device: "http://192.168.234.208/cent-device",
      socketLogin: "http://192.168.234.208/cent-message",
      business: "http://192.168.234.208/platform-business",
      park: "http://192.168.234.208/cent-zone-operation",
      eesd: "http://192.168.234.208/cent-eesd",
      auth: "http://192.168.234.208/cent-auth",
      ifmDynamicServeUrl: "http://192.168.234.208/cent-consumer",
      residence: "http://192.168.234.208/platform-residence",
      finance: "http://192.168.234.208/cent-biz-fin",
      face: "http://192.168.234.208/cent-face",
      iotDate: "http://192.168.234.208/cent-iot-data/",
      industrial: "http://192.168.234.208/platform-industrial",
      upgrade: "http://192.168.234.208/cent-upgrade",
      attendance: "http://192.168.234.208/cent-attendance",
      product: "http://192.168.234.208/cent-product",
      flow: "http://192.168.234.208/cent-workflow",
      h5View: "/h5/view/",
      healthAged: "http://192.168.234.208/platform-health-aged",
      smarthome: "http://192.168.234.208/cent-smarthome",
      meeting: "http://192.168.234.208/cent-boardroom",
      oam: "http://192.168.234.208/cent-oam",
      iotProduct: "http://192.168.234.208/productcore-webapi",
      iotService: "http://192.168.234.208/devicecore-webapi",
      initConfig: "http://192.168.234.208/cent-init-config",
      iot: "http://192.168.234.208/iot-webapi",
    },
    production: {
      common: "https://admin.smartzdpi.com:9443",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://admin.smartzdpi.com:9443/cent-data-core",
      workorder: "https://admin.smartzdpi.com:9443/cent-order",
      school: "https://admin.smartzdpi.com:9443/platform-campus",
      patrol: "https://admin.smartzdpi.com:9443/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://admin.smartzdpi.com:9443/cent-question",
      security: "https://admin.smartzdpi.com:9443/cent-security",
      vehicle: "https://admin.smartzdpi.com:9443/cent-vehicle",
      mApi: "https://cent.xhmind.com",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://admin.smartzdpi.com:9443/cent-talkback",
      device: "https://admin.smartzdpi.com:9443/cent-device",
      socketLogin: "https://admin.smartzdpi.com:9443/cent-message",
      business: "https://admin.smartzdpi.com:9443/platform-business",
      park: "https://admin.smartzdpi.com:9443/cent-zone-operation",
      eesd: "https://admin.smartzdpi.com:9443/cent-eesd",
      auth: "https://admin.smartzdpi.com:9443/cent-auth",
      ifmDynamicServeUrl: "https://admin.smartzdpi.com:9443/cent-consumer",
      residence: "https://admin.smartzdpi.com:9443/platform-residence",
      finance: "https://admin.smartzdpi.com:9443/cent-biz-fin",
      face: "https://admin.smartzdpi.com:9443/cent-face",
      iotDate: "https://admin.smartzdpi.com:9443/cent-iot-data/",
      industrial: "https://admin.smartzdpi.com:9443/platform-industrial",
      upgrade: "https://admin.smartzdpi.com:9443/cent-upgrade",
      attendance: "https://admin.smartzdpi.com:9443/cent-attendance",
      product: "https://admin.smartzdpi.com:9443/cent-product",
      flow: "https://admin.smartzdpi.com:9443/cent-workflow",
      h5View: "/h5/view/",
      healthAged: "https://admin.smartzdpi.com:9443/platform-health-aged",
      smarthome: "https://admin.smartzdpi.com:9443/cent-smarthome",
      meeting: "https://admin.smartzdpi.com:9443/cent-boardroom",
      oam: "https://admin.smartzdpi.com:9443/cent-oam",
      iotProduct: "https://admin.smartzdpi.com:9443/productcore-webapi",
      iotService: "https://admin.smartzdpi.com:9443/devicecore-webapi",
      initConfig: "https://admin.smartzdpi.com:9443/cent-init-config",
      iot: "https://admin.smartzdpi.com:9443/iot-webapi",
    },
  },
  zjwj: {
    production: {
      common: "https://bip.cscec5b.com.cn:21558",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://bip.cscec5b.com.cn:21558/cent-data-core",
      workorder: "https://bip.cscec5b.com.cn:21558/cent-order",
      school: "https://bip.cscec5b.com.cn:21558/platform-campus",
      patrol: "https://bip.cscec5b.com.cn:21558/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://bip.cscec5b.com.cn:21558/cent-question",
      security: "https://bip.cscec5b.com.cn:21558/cent-security",
      vehicle: "https://bip.cscec5b.com.cn:21558/cent-vehicle",
      mApi: "https://cent.xhmind.com",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://bip.cscec5b.com.cn:21558/cent-talkback",
      device: "https://bip.cscec5b.com.cn:21558/cent-device",
      socketLogin: "https://bip.cscec5b.com.cn:21558/cent-message",
      business: "https://bip.cscec5b.com.cn:21558/platform-business",
      park: "https://bip.cscec5b.com.cn:21558/cent-zone-operation",
      eesd: "https://bip.cscec5b.com.cn:21558/cent-eesd",
      auth: "https://bip.cscec5b.com.cn:21558/cent-auth",
      ifmDynamicServeUrl: "https://bip.cscec5b.com.cn:21558/cent-consumer",
      residence: "https://bip.cscec5b.com.cn:21558/platform-residence",
      finance: "https://bip.cscec5b.com.cn:21558/cent-biz-fin",
      face: "https://bip.cscec5b.com.cn:21558/cent-face",
      iotDate: "https://bip.cscec5b.com.cn:21558/cent-iot-data/",
      industrial: "https://bip.cscec5b.com.cn:21558/platform-industrial",
      upgrade: "https://bip.cscec5b.com.cn:21558/cent-upgrade",
      attendance: "https://bip.cscec5b.com.cn:21558/cent-attendance",
      product: "https://bip.cscec5b.com.cn:21558/cent-product",
      flow: "https://bip.cscec5b.com.cn:21558/cent-workflow",
      h5View: "/h5/view/",
      healthAged: "https://bip.cscec5b.com.cn:21558/platform-health-aged",
      smarthome: "https://bip.cscec5b.com.cn:21558/cent-smarthome",
      meeting: "https://bip.cscec5b.com.cn:21558/cent-boardroom",
      oam: "https://bip.cscec5b.com.cn:21558/cent-oam",
      iotProduct: "https://bip.cscec5b.com.cn:21558/productcore-webapi",
      iotService: "https://bip.cscec5b.com.cn:21558/devicecore-webapi",
      initConfig: "https://bip.cscec5b.com.cn:21558/cent-init-config",
      iot: "https://bip.cscec5b.com.cn:21558/iot-webapi",
    },
  },
  nfmg: {
    development: {
      common: "http://192.168.5.8:9900",
      ifm: "https://ifm.zj.xhmind.com",
      main: "http://192.168.5.8:9900/cent-data-core",
      workorder: "http://192.168.5.8:9900/cent-order",
      school: "http://192.168.5.8:9900/platform-campus",
      patrol: "http://192.168.5.8:9900/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "http://192.168.5.8:9900/cent-question",
      security: "http://192.168.5.8:9900/cent-security",
      vehicle: "http://192.168.5.8:9900/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "http://192.168.5.8:9900/cent-talkback",
      device: "http://192.168.5.8:9900/cent-device",
      socketLogin: "http://192.168.5.8:9900/cent-message",
      business: "http://192.168.5.8:9900/platform-business",
      park: "http://192.168.5.8:9900/cent-zone-operation",
      eesd: "http://192.168.5.8:9900/cent-eesd",
      auth: "http://192.168.5.8:9900/cent-auth",
      ifmDynamicServeUrl: "http://192.168.5.8:9900/cent-consumer",
      residence: "http://192.168.5.8:9900/platform-residence",
      finance: "http://192.168.5.8:9900/cent-biz-fin",
      face: "http://192.168.5.8:9900/cent-face",
      iotDate: "http://192.168.5.8:9900/cent-iot-data/",
      industrial: "http://192.168.5.8:9900/platform-industrial",
      upgrade: "http://192.168.5.8:9900/cent-upgrade",
      attendance: "http://192.168.5.8:9900/cent-attendance",
      product: "http://192.168.5.8:9900/cent-product",
      flow: "http://192.168.5.8:9900/cent-workflow",
      sdkAppId: 1400528184,
      lanTalkWebSocket: "ws://10.10.101.102:9250",
      lanTalk: "http://10.10.101.102:9250",
      h5View: "/h5/view/",
      healthAged: "http://192.168.5.8:9900/platform-health-aged",
      smarthome: "http://192.168.5.8:9900/cent-smarthome",
      meeting: "http://192.168.5.8:9900/cent-boardroom",
      baiduAk: "7cPwN5IjZTC5i2tUrcejkOZWrQKSua6s",
      oam: "http://192.168.5.8:9900/cent-oam",
      iotProduct: "http://192.168.5.8:9900/productcore-webapi",
      iotService: "http://192.168.5.8:9900/devicecore-webapi",
      initConfig: "http://192.168.5.8:9900/cent-init-config",
      iot: "http://192.168.5.8:9900/iot-webapi",
    },
    test: {
      common: "https://beautyhuangpu.com/api",
      ifm: "https://ifm.zj.xhmind.com",
      main: "https://beautyhuangpu.com/api/cent-data-core",
      workorder: "https://beautyhuangpu.com/api/cent-order",
      school: "https://beautyhuangpu.com/api/platform-campus",
      patrol: "https://beautyhuangpu.com/api/cent-alarm",
      faceService: "https://face.xymind.net:14244",
      baseUrl: "https://beautyhuangpu.com/api/cent-question",
      security: "https://beautyhuangpu.com/api/cent-security",
      vehicle: "https://beautyhuangpu.com/api/cent-vehicle",
      mApi: "https://mr.xymind.net:13001",
      filesUpload: "https://seven.xy-mind.com:18443",
      cloudTalk: "https://beautyhuangpu.com/api/cent-talkback",
      device: "https://beautyhuangpu.com/api/cent-device",
      socketLogin: "https://beautyhuangpu.com/api/cent-message",
      business: "https://beautyhuangpu.com/api/platform-business",
      park: "https://beautyhuangpu.com/api/cent-zone-operation",
      eesd: "https://beautyhuangpu.com/api/cent-eesd",
      auth: "https://beautyhuangpu.com/api/cent-auth",
      ifmDynamicServeUrl: "https://beautyhuangpu.com/api/cent-consumer",
      residence: "https://beautyhuangpu.com/api/platform-residence",
      finance: "https://beautyhuangpu.com/api/cent-biz-fin",
      face: "https://beautyhuangpu.com/api/cent-face",
      iotDate: "https://beautyhuangpu.com/api/cent-iot-data/",
      industrial: "https://beautyhuangpu.com/api/platform-industrial",
      upgrade: "https://beautyhuangpu.com/api/cent-upgrade",
      attendance: "https://beautyhuangpu.com/api/cent-attendance",
      product: "https://beautyhuangpu.com/api/cent-product",
      flow: "https://beautyhuangpu.com/api/cent-workflow",
      sdkAppId: 1400528184,
      lanTalkWebSocket: "ws://10.10.101.102:9250",
      lanTalk: "http://10.10.101.102:9250",
      h5View: "/h5/view/",
      healthAged: "https://beautyhuangpu.com/api/platform-health-aged",
      smarthome: "https://beautyhuangpu.com/api/cent-smarthome",
      meeting: "https://beautyhuangpu.com/api/cent-boardroom",
      baiduAk: "7cPwN5IjZTC5i2tUrcejkOZWrQKSua6s",
      oam: "https://beautyhuangpu.com/api/cent-oam",
      iotProduct: "https://beautyhuangpu.com/api/productcore-webapi",
      iotService: "https://beautyhuangpu.com/api/devicecore-webapi",
      initConfig: "https://beautyhuangpu.com/api/cent-init-config",
      iot: "https://beautyhuangpu.com/api/iot-webapi",
    },
    production: {

    }
  }
}
